module.exports = __webpack_public_path__ + "img/icon_benefit_03_w.500b8291.svg";